// extracted by mini-css-extract-plugin
module.exports = {"heading":"block_heading__RI8bu","divider":"block_divider__gIMe0"};